module.exports = __webpack_public_path__ + "static/media/unsplash-2.4a185a81.jpg";